import React from "react";
import ReactECharts from "echarts-for-react";
const { useState, useEffect } = React;

const Page = ({ width = "100%", options }) => {
  const [dynamicHeight, setDynamicHeight] = useState("200px");

  useEffect(() => {
    function handleResize() {
      setDynamicHeight(window.innerWidth < 768 ? "300px" : "250px");
    }

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <ReactECharts option={options} style={{ height: dynamicHeight, width }} />
  );
};

export default Page;
